import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import Supplier from "./Supplier";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import OrderDetails from "./OrderDetails";
import SupplierDetails from "./SupplierDetails";
import Fulfillment from "./Fulfillment";
import SupplierFulfillment from "./SupplierFulfillment";

ReactDOM.render(
	<React.StrictMode>
		<Router>
			<Routes>
				<Route path="/orders">
					<Route path=":id" element={<OrderDetails />} />
					<Route path="old/:base/:id" element={<OrderDetails />} />
				</Route>
				<Route path="/fulfillment">
					<Route path=":id" element={<Fulfillment />} />
					<Route path="old/:base/:id" element={<Fulfillment />} />
				</Route>


				<Route path="/supplier/:id" element={<SupplierDetails />} />
				<Route
					path="/supplier/fulfillment/:id"
					element={<SupplierFulfillment />}
				/>
				<Route path="/supplier" element={<Supplier />} />
				<Route path="/" element={<App />} />
			</Routes>
		</Router>
	</React.StrictMode>,
	document.getElementById("root")
);
